export enum RouteExportRowType {
  ROUTE = "ROUTE",
  TASK = "TASK",
  DROPOFFS = "DROPOFFS_ONLY",
  GROUPED_DROPOFFS = "GROUPED_DROPOFFS"
}
